module.exports = __webpack_public_path__ + "img/mindar.2db586a8.png";